/**
 * @learnzapp/core/theme — the single source of truth for colors in BOTH apps.
 *
 * - ./baseColors  canonical light/dark color scales (BASE_COLORS_LIGHT/_DARK)
 * - ./colorUtils  pure hex/rgba helpers (lighten, darken, addOpacity, …)
 * - ./palette     active-brand base-scale resolver (resolveBase)
 * - ./themes      assembled theme objects + getColorTheme(mode, platform)
 *
 * A brand's colors are DATA in configs/_shared (theme.defaults.js + <brand>/theme.js), baked by the
 * switch script into ./generated/activeBrandScales.js. The OKLCH engine is BUILD/TEST ONLY:
 * generate.js / resolve.js / bakeRecipe.js import culori; baseScales.js + generated/*.js are the
 * baked, culori-free runtime data. See ./README.md for the full file map + the culori boundary.
 *
 * Pure data and pure functions only — no platform SDKs, no UI. Each app's
 * ThemeProvider stays in the app (localStorage vs Firebase/Appearance is
 * platform plumbing); only the values it serves come from here.
 *
 * NOTE: the generator (generate.js / resolve.js / bakeRecipe.js) is intentionally NOT re-exported —
 * it pulls culori into the app bundle, and culori's browser build is a global IIFE that breaks under
 * webpack (enforced by __tests__/bundle-boundary.test.js). Import it directly only in Node/build/test.
 */
export * from './colorUtils';
export * from './baseColors';
export * from './palette';
export * from './themes';
export * from './toneColors';
export * from './menuChips';
